import React from 'react';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

/**
 * Styled Switch component with custom sizing
 * Uses MUI's default color theming, only customizes dimensions
 */
const CustomSwitchRoot = styled(Switch)(({ theme }) => ({
  width: 44,
  height: 24,
  padding: 0,
  borderRadius: 12,
  flexShrink: 0,
  
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    
    '&.Mui-checked': {
      transform: 'translateX(20px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
    },
    
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      border: '6px solid #fff',
    },
  },
  
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 20,
    height: 20,
    boxShadow: theme.shadows[1],
    background: '#fff',
    borderRadius: '50%',
  },
  
  '& .MuiSwitch-track': {
    borderRadius: 12,
    opacity: 0.3,
    transition: theme.transitions.create(['background-color', 'opacity'], {
      duration: 500,
    }),
  },
}));

/**
 * Custom Switch component with consistent sizing
 * Uses MUI's default theming, only customizes dimensions for consistency
 * 
 * @component
 * @example
 * // Basic usage
 * <Switch 
 *   checked={isEnabled} 
 *   onChange={handleToggle} 
 * />
 * 
 * @example
 * // With custom color (uses MUI's default color system)
 * <Switch 
 *   checked={isActive} 
 *   onChange={handleActiveToggle}
 *   color="success"
 * />
 * 
 * @example
 * // Disabled state
 * <Switch 
 *   checked={isEnabled} 
 *   onChange={handleToggle}
 *   disabled={true}
 * />
 * 
 * @param {Object} props - Component props (all MUI Switch props supported)
 * @param {Object} ref - Forwarded ref
 * @returns {JSX.Element} Custom Switch component
 */
const CustomSwitch = React.forwardRef(function CustomSwitch(props, ref) {
  return <CustomSwitchRoot ref={ref} {...props} />;
});

export default CustomSwitch;
